import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Flex } from 'grid-styled';
import Container from 'components/Container';
import media from 'utils/media';
import { FONT_FAMILIES, COLOR, FONT_SIZES, SPACE } from 'config';
import Content from '../Content';
import Button from '../Button';
import Logo from '../Logo';

const Wrapper = styled(Flex)`
  position: relative;
  box-sizing: border-box;
  background: ${COLOR.base} url(${props => props.banner}) no-repeat right bottom;
  overflow: hidden;
  background-color: white;
  background-size: contain;
  padding-bottom: 3rem;
  ${media.md.css`
  padding-bottom: 5rem;
  `}
  ${media.customLG.css`
  padding-bottom: 2rem;
  `}
`;

const Intro = styled(Flex)`
  position: relative;
  z-index: 1;
`;

const IntroContent = styled(Flex)`
  position: relative;
  z-index: 1;
  flex-direction:column; 
  justify-content:center !important;
  width: 100%;
  ${media.sm.css`
  width: 100%;
  `}
  ${media.md.css`
  width: 515px;
  `}
  ${media.lg.css`
  width: 515px;
  `}
`;

const StyledIntro = styled(Intro)`
  margin-top: ${rem(SPACE[5])};
  top: 0;
  height: 100%;
  width: 100%;
  ${media.md.css`
  margin-top: 0;
  `};
`;

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: row;
  padding: 0 !important;
`;

const StyledLogoContainer = styled.div`
  top: 5%;
  width: 100%;
`;

const Paragraph = styled.p`
  font-size: ${props => props.fontSize};
  color: ${props => props.color};
  font-family: ${FONT_FAMILIES.sans};
  font-weight: ${props => props.fontWeight};
  line-height: 2rem;
  text-transform: none;
`;

const ButtonsContainer = styled(Flex)`
  flex-direction: column;
  a:first-child {
    margin-right: 20px;
  }

  ${media.md.css`
  flex-direction: row;
  `}
`;

const ImageHeaderContainer = styled.div`
  width: 100%;
  max-width: 65rem;
  position: absolute;
  margin: auto;
  margin-top: -2.8rem;
`;

const ImageHeader = styled.img`
  height: 100%;
  position: absolute;
  right: -200px;
  top: 5rem;
  opacity: 0;
  transition: 300ms ease forward;
  ${media.sm.css`
  top: 3rem;
  height: 300px;
  right: -150px;
  opacity: 0;
  `}
  ${media.md.css`
  right: -100px;
  width: auto;
  height: 400px;
  top: 3rem;
  opacity: 1;
  `}
  ${media.lg.css`
  opacity: 1;
  top: 3rem;
  right: 0;
  `}
`;

const Hero = ({
  description,
  description2,
  to,
  to2,
  buttonText,
  buttonText2,
  banner,
}) => (
  <Wrapper
    column
    pb={[SPACE[1], SPACE[8], SPACE[13]]}
    px={[rem(SPACE[5]), rem(SPACE[5]), rem(SPACE[5])]}
  >
    <Content mx="auto">
      <ImageHeaderContainer>
        <ImageHeader src={banner} />
      </ImageHeaderContainer>
      <StyledIntro marginTop={rem(SPACE[10])}>
        <StyledContainer>
          <IntroContent>
            <StyledLogoContainer>
              <StyledContainer>
                <Logo />
              </StyledContainer>
            </StyledLogoContainer>
            <Paragraph
              heavy
              as="h1"
              fontSize={rem(FONT_SIZES[5])}
              color={COLOR.base}
              fontWeight={700}
            >
              <FormattedMessage id={description} />
            </Paragraph>
            <Paragraph
              heavy
              as="h1"
              fontSize={rem(FONT_SIZES[3])}
              color={COLOR.textDark}
            >
              <FormattedMessage id={description2} />
            </Paragraph>
            <ButtonsContainer flexDirection="row" width={[1, 1, 1]}>
              <Button
                to={to}
                width={['100%', '100%', 'auto']}
                big
              >
                <FormattedMessage id={buttonText} />
              </Button>
              <Button
                to={to2}
                backgroundColor={COLOR.dark}
                width={['100%', '100%', 'auto']}
                big
              >
                <FormattedMessage id={buttonText2} />
              </Button>
            </ButtonsContainer>
          </IntroContent>
        </StyledContainer>
      </StyledIntro>
    </Content>
  </Wrapper>
);

Hero.propTypes = {
  description: PropTypes.string.isRequired,
  description2: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonText2: PropTypes.string.isRequired,
  banner: PropTypes.element.isRequired,
  to: PropTypes.string.isRequired,
  to2: PropTypes.string.isRequired,
};


export default Hero;



// WEBPACK FOOTER //
// ./src/components/NYCMeetUpLanding/components/Hero/Hero.js